import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=acaf0844&scoped=true"
import script from "./UserAccount.vue?vue&type=script&lang=js"
export * from "./UserAccount.vue?vue&type=script&lang=js"
import style0 from "./UserAccount.vue?vue&type=style&index=0&id=acaf0844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaf0844",
  null
  
)

export default component.exports